import { personasServices } from '../../../hexagonal-architecture-frontend-base/src/infrastructure/services/personas.service';
import { personasRepositoryInstance } from '../../../hexagonal-architecture-frontend-base/src/infrastructure/instances/personasRepository';
import { createGetPatientsExtraInfoService } from '../create-get-patients-extra-info.service';
import { PatientQuote } from '../../../ts';

const fetchFunction = personasServices(personasRepositoryInstance).getAllPatientReports;

export const getPatientsQuotesService =
  createGetPatientsExtraInfoService<PatientQuote>(fetchFunction);
